import { useEffect, useRef, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useAppDispatch } from 'lib/redux/hooks';
import { authActions } from './authSlice';
import { choseCustomerActions } from './choseCustomerSlice';

export function useInitializeCustomerFromPath(): boolean {
  const [ready, setReady] = useState(false);
  const [searchParams] = useSearchParams();
  const dispatch = useAppDispatch();
  const initialized = useRef(false);

  useEffect(() => {
    if (initialized.current) return;
    initialized.current = true;

    const customerNumber = searchParams.get('customerNumber');
    if (customerNumber) {
      dispatch(choseCustomerActions.reset());
      dispatch(authActions.setCustomer(customerNumber));
    }
    setReady(true);
  }, [dispatch, searchParams]);

  return ready;
}